import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, Platform } from 'ionic-angular';
import { HomePage } from '../../home/home/home';
import { ViewChild } from '@angular/core';
import { Navbar } from 'ionic-angular';


/**
 * Generated class for the SiteMaintenancePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-site-maintenance',
  templateUrl: 'site-maintenance.html',
})
export class SiteMaintenancePage {
  @ViewChild(Navbar) navBar: Navbar;
  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    
    // this.navBar.backButtonClick = (e:UIEvent)=>{
    //   // todo something
    //   this.navCtrl.setRoot(HomePage);
    //  }
  }

  refresh_page(){
    this.navCtrl.setRoot(HomePage);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/site-maintenance/site-maintenance.ts